<template>
  <div>
    <el-tooltip :content="$t('system_account.update.updateBtnTooltip')"
                effect="light"
                :open-delay="300"
                placement="bottom">
      <base-button icon round type="info" @click="modal = true" class="text-nowrap zi_100">
        <i class="mdi mdi_icon mdi-24px mdi-pencil-outline"/>
      </base-button>
    </el-tooltip>
    <modal id="editSystemAccount"
           :show.sync="modal"
           modal-classes="modal-dialog-centered modal-lg"
           showClose @close="resetForm()">
      <template slot="header">
        <h4 class="modal-title">
          {{ $t('system_account.update.titleText') }}
        </h4>
      </template>
      <template>
        <div class="text-center text-muted mb-2">
          <small>{{ $t('system_account.update.helpText') }}</small>
        </div>

        <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
          <!-- TODO: add error translation -->
          {{ getActionErrorDetails }}
        </base-alert>

        <form role="form" v-on:submit.prevent="validate()">
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('system_account.details.username') }}</label>
            <div class="col">
              <base-input
                disabled="true"
                type="username"
                name="username"
                v-model="system_account.username"
              >
              </base-input>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('system_account.details.first_name') }}</label>
            <div class="col">
              <base-input
                name="first_name"
                v-validate="modelValidations.required"
                :error="getError('first_name')"
                v-model="system_account.first_name"
              >
              </base-input>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('system_account.details.last_name') }}</label>
            <div class="col">
              <base-input
                type="username"
                name="last_name"
                v-validate="modelValidations.required"
                :error="getError('last_name')"
                v-model="system_account.last_name"
              >
              </base-input>
            </div>
          </div>

          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('system_account.details.email') }}</label>
            <div class="col">
              <base-input
                type="email"
                name="email"
                v-validate="modelValidations.email"
                :error="getError('email')"
                v-model="system_account.email"
              >
              </base-input>
            </div>
          </div>

          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('system_account.details.contact_number') }}</label>
            <div class="col">
              <base-input
                type="string"
                name="number"
                v-model="system_account.contact_number"
              >
              </base-input>
            </div>
          </div>

          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('system_account.details.organisation') }}</label>
            <div class="col">
              <base-input
                type="string"
                v-model="system_account.organisation"
              >
              </base-input>
            </div>
          </div>

          <!-- language select -->
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('system_account.details.language') }}</label>
            <div class="col form-group">
              <el-select
                class="select-primary"
                name="role"
                v-model="system_account.language"
              >
                <el-option
                  v-for="option in availableLanguages"
                  class="select-primary"
                  :value="option"
                  :label="option"
                  :key="option"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('system_account.details.cidrs') }}</label>
            <div class="col">
              <div class="form-group">
                <tags-input v-model="system_account.cidrs"
                            :input-placeholder="$t('system_account.form.cidrPlaceholder')"
                            input-size="" tag-size="medium"></tags-input>
              </div>
            </div>
          </div>

          <!-- role select -->
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('system_account.details.role') }}</label>
            <div class="col form-group">
              <el-select
                class="select-primary"
                name="role"
                :placeholder="$t('system_account.form.rolePlaceholder')"
                v-model="system_account.role"
              >
                <el-option
                  v-for="option in availableRoles"
                  class="select-primary"
                  :value="option.value"
                  :label="$t(`roleNames.${option.value}`)"
                  :key="option.label"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <!-- status select -->
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('system_account.details.status') }}</label>
            <div class="col form-group">
              <el-select
                class="select-primary"
                name="role"
                v-model="system_account.status"
              >
                <el-option
                  v-for="option in availableStatuses"
                  class="select-primary"
                  :value="option"
                  :label="option"
                  :key="option"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="text-center">
            <base-button
              :loading="loading"
              type="primary"
              class="my-4"
              @click="validate()"
            >{{ $t('system_account.update.actionBtnLabel') }}
            </base-button>
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>


<script>
import {BaseAlert, Modal, TagsInput} from 'src/components';
import {Option, Select} from 'element-ui';
import {mapActions, mapState} from "vuex";
import languages from "./languages";

export default {
  name: 'edit-system-accounts',
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    Modal,
    BaseAlert,
    TagsInput
  },
  data() {
    return {
      modal: false,
      alert: false,
      system_account: {
        username: '',
        email: '',
        first_name: '',
        last_name: '',
        role: '',
        contact_number: '',
        organisation: '',
        cidrs: [],
        language: '',
        status: 'unknown'
      },
      modelValidations: {
        required: {
          required: true
        },
        email: {
          email: true
        },
        number: {
          numeric: true
        }
      },
      availableStatuses: ["ok", "suspended"],
      availableLanguages: languages
    }
  },
  computed: {
    ...mapState({
      loading: state => state.system_account.updating,
      error: state => state.system_account.error,
      roles: state => state.role.roles,
    }),

    getActionErrorDetails() {
      return this.error;
    },
    availableRoles: function () {
      let existingRoles = []
      for (let i = 0; i < this.roles.length; i++) {
        existingRoles.push({
          value: this.roles[i].name,
          label: this.roles[i].name,
        })
      }
      // Add `admin` role
      existingRoles.push({
        value: 'admin',
        label: 'admin',
      })
      return existingRoles
    }
  },
  methods: {
    ...mapActions(['GetSystemAccount', 'UpdateSystemAccount']),
    resetForm: function () {
      this.modal = false;
      this.alert = false;
      // reset validation errors
      this.$validator.reset()
      this.system_account = {
        username: '',
        email: '',
        first_name: '',
        last_name: '',
        role: '',
        contact_number: '',
        organisation: '',
        cidrs: [],
        language: '',
        status: 'unknown'
      }
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.update()
        }
      });
    },
    handleRoleChange: function (role) {
      this.system_account.role = role
    },
    update: function () {
      this.alert = false
      this.UpdateSystemAccount(this.system_account).then(() => {
        if (this.error != null) {
          this.alert = true
        } else {
          this.$notify({
            type: 'success',
            message: this.$t('system_account.update.updatedNotification', {username: this.system_account.username}),
            icon: 'tim-icons icon-alert-circle-exc'
          })
          this.GetSystemAccount(this.system_account.id);
          this.resetForm()
        }
      });
    }
  },
  watch: {
    // Watch if modal is open and prepare data to edit.
    modal(newValue) {
      if (newValue) {
        let details = this.$store.state.system_account.single
        this.system_account = {
          id: details.id,
          contact_number: details.contact_number,
          email: details.email,
          first_name: details.first_name,
          last_name: details.last_name,
          role: details.role,
          username: details.username,
          organisation: details.organisation,
          cidrs: details.cidrs,
          language: details.language,
          status: details.status,
        }
      }
    },
  }
}
</script>
